import styled from '@emotion/styled';
import colors from '../../styling/colors';
import typography from '../../styling/mixins/typography';

const h1 = styled.h1`
  ${typography.headingXLarge};
  ${({
    theme: {
      Heading: { fontStyleCss },
    },
  }) => fontStyleCss};
  ${({ color }) => color && `color: ${colors(color)}`};
`;

const h2 = styled.h2`
  ${typography.headingLarge};
  ${({
    theme: {
      Heading: { fontStyleCss },
    },
  }) => fontStyleCss};
  ${({ color }) => color && `color: ${colors(color)}`};
`;

const h3 = styled.h3`
  ${typography.headingMedium};
  ${({
    theme: {
      Heading: { fontStyleCss },
    },
  }) => fontStyleCss};
  ${({ color }) => color && `color: ${colors(color)}`};
`;

const h4 = styled.h4`
  ${typography.headingSmall};
  ${({
    theme: {
      Heading: { fontStyleCss },
    },
  }) => fontStyleCss};
  ${({ color }) => color && `color: ${colors(color)}`};
`;

const h5 = styled.h5`
  ${typography.headingXSmall};
  ${({
    theme: {
      Heading: { fontStyleCss },
    },
  }) => fontStyleCss};
  ${({ color }) => color && `color: ${colors(color)}`};
`;

const h6 = styled.h6`
  ${typography.trackedStyles};
  ${({
    theme: {
      Heading: { fontStyleCss },
    },
  }) => fontStyleCss};
  ${({ color }) => color && `color: ${colors(color)}`};
`;

const Heading = {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
};

const fullWidthHeading = level => {
  return styled(Heading['h' + level])`
    width: 100%;
  `;
};

export { fullWidthHeading, Heading };

export default Heading;
